import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  private translations: any;

  constructor(private http: HttpClient) {}
  
  loadTranslations(lang: string): Observable<void> {
    return this.http
      .get<any>(`assets/i18n/ro.json`)
      .pipe(
        tap((translationData) => {
          this.translations[lang] = translationData;
        }),
        catchError(() => of(null))
      );
  }

  getTranslation(key: string, lang: string): string {
    return this.translations[lang]?.[key] || key;
  }
}
